module.exports = __webpack_public_path__ + "img/top_bg.c0beb2be.png";